import { LandingPage } from "../models/landing-page.enum";

export class Applications {
    public static get fleetManager(): AppArea  {
        return {
            name: 'Fleet Manager',
            landingPageUrl: LandingPage.FleetManager
        };
    }
    public static get portal(): AppArea {
        return {
            name: 'Portal',
            landingPageUrl: LandingPage.Factoring
        };
    }

    public static get carrier(): AppArea {
        return {
            name: 'Carrier',
            landingPageUrl: LandingPage.Carrier
        };
    }
}


export interface AppArea {
    name: string;
    landingPageUrl: string;
}


// WEBPACK FOOTER //
// ./src/app/core/constants/applications.ts